/** Shared upload bucket config for all BTL borrower-type forms */

export const UPLOAD_FORMAT_HINT = "PDF, JPG, or PNG up to 10MB per file.";

export const BORROWER_UPLOAD_BUCKETS = [
  {
    key: "borrower_bank_statements",
    fieldname: "borrower_bank_statements",
    title: "3 months bank statements",
    multiple: true,
    button: "Select Files",
  },
  {
    key: "borrower_portfolio",
    fieldname: "borrower_portfolio",
    title: "Property Portfolio",
    multiple: false,
  },
  {
    key: "app_assets_liability",
    fieldname: "app_assets_liability",
    title: "Assets & Liability Statement",
    multiple: false,
  },
  {
    key: "app_personal_bank",
    fieldname: "app_personal_bank",
    title: "3 months Personal Bank statements",
    multiple: true,
    button: "Select Files",
  },
  {
    key: "app_id",
    fieldname: "app_id",
    title: "Identification — Passport and/or Driver's Licence",
    multiple: true,
    button: "Upload Documents",
  },
  {
    key: "borrower_accounts",
    fieldname: "borrower_accounts",
    title: "Property Accounts",
    multiple: false,
  },
  {
    key: "app_self_employed",
    fieldname: "app_self_employed",
    title: "Self Employed — Last 2 years Tax Returns",
    multiple: true,
    button: "Upload Documents",
  },
  {
    key: "app_employed",
    fieldname: "app_employed",
    title: "Employed — P60 and 3 months Payslips",
    multiple: true,
    button: "Upload Documents",
  },
];

export const ALL_UPLOAD_BUCKETS = BORROWER_UPLOAD_BUCKETS;

/** IF Applications DocType Attach fields (exact backend fieldnames). */
export const IF_UPLOAD_BUCKETS = [
  {
    key: "if_full_annual_business_accounts",
    fieldname: "if_full_annual_business_accounts",
    title: "Full annual business accounts",
    multiple: false,
  },
  {
    key: "if_management_accounts",
    fieldname: "if_management_accounts",
    title: "Management accounts",
    multiple: false,
  },
  {
    key: "if_3_months_business_bank_statement",
    fieldname: "if_3_months_business_bank_statement",
    title: "3 months Business bank statements",
    multiple: true,
    button: "Select Files",
  },
  {
    key: "if_aged_debtors",
    fieldname: "if_aged_debtors",
    title: "Aged Debtors",
    multiple: false,
  },
  {
    key: "if_aged_creditors",
    fieldname: "if_aged_creditors",
    title: "Aged Creditors",
    multiple: false,
  },
  {
    key: "if_id_passport",
    fieldname: "if_id_passport",
    title: "ID",
    multiple: true,
    button: "Upload Documents",
  },
];

/** Legacy frontend keys → current IF Applications Attach fieldnames */
export const IF_UPLOAD_FIELD_ALIASES = {
  if_annual_accounts: "if_full_annual_business_accounts",
  if_full_annual_business_accounts: "if_full_annual_business_accounts",
  if_management_accounts: "if_management_accounts",
  if_business_bank: "if_3_months_business_bank_statement",
  if_business_bank_statements: "if_3_months_business_bank_statement",
  if_3_months_business_bank_statement: "if_3_months_business_bank_statement",
  if_aged_debtor: "if_aged_debtors",
  if_aged_debtors: "if_aged_debtors",
  if_aged_creditor: "if_aged_creditors",
  if_aged_creditors: "if_aged_creditors",
  if_id_passport: "if_id_passport",
};

export const FORM_WIZARD_STEPS = [
  { id: "details", label: "Your details" },
  { id: "property", label: "Property & finance" },
  { id: "documents", label: "Documents" },
  { id: "review", label: "Review" },
];

export const IF_FORM_WIZARD_STEPS = [
  { id: "details", label: "Your details" },
  { id: "documents", label: "Documents" },
  { id: "review", label: "Review" },
];

export function countUploadedBuckets(uploads = {}, buckets = ALL_UPLOAD_BUCKETS) {
  const keys = buckets.map((b) => b.key);
  let uploaded = 0;
  keys.forEach((key) => {
    const files = uploads[key];
    if (Array.isArray(files) && files.length > 0) uploaded += 1;
  });
  return { uploaded, total: keys.length };
}

export function normalizeIfUploads(uploads = {}) {
  const next = { ...uploads };
  Object.entries(IF_UPLOAD_FIELD_ALIASES).forEach(([legacyKey, canonicalKey]) => {
    if (legacyKey === canonicalKey) return;
    if (Array.isArray(next[legacyKey]) && next[legacyKey].length > 0 && !next[canonicalKey]?.length) {
      next[canonicalKey] = next[legacyKey];
    }
  });
  return next;
}
